import z from "zod";

export const ExcerptFieldSchema = z.object({
    excerpt: z.string()
});

export const PathFieldSchema = z.object({
    path: z.string().startsWith("/")
});

export const ReadingTimeSchema = z.object({ readingTime: z.number() });

export const CanonicalUrlSchema = z.object({ canonical: z.string().startsWith("/") });
